"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_d3_tree_1 = __importDefault(require("react-d3-tree"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var node_data_view_component_1 = __importDefault(require("./node-data-view.component"));

var scenario_tree_view_styles_1 = require("./scenario-tree-view.styles");

var ScenarioTreeView = function ScenarioTreeView(_ref) {
  var treeData = _ref.treeData,
      handleEditClick = _ref.handleEditClick;

  var _react_1$useState = react_1.useState(1),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      depth = _react_1$useState2[0],
      setDepth = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(0),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      cntRender = _react_1$useState4[0],
      setCntRender = _react_1$useState4[1];

  var renderDepth = function renderDepth(d) {
    setDepth(d);
    setCntRender(cntRender + 1);
  };

  var pathFunc = function pathFunc(linkData) {
    var beginPoint = "".concat(linkData.source.y, ",").concat(linkData.source.x);
    var midPoint1 = "".concat(linkData.source.y * 0.5 + linkData.target.y * 0.5, ",").concat(linkData.source.x);
    var midPoint2 = "".concat(linkData.source.y * 0.3 + linkData.target.y * 0.7, ",").concat(linkData.target.x);
    var endPoint = "".concat(linkData.target.y, ",").concat(linkData.target.x);
    return "M".concat(beginPoint, "L").concat(midPoint1, "L").concat(midPoint2, "L").concat(endPoint);
  };

  return react_1.default.createElement(scenario_tree_view_styles_1.StyledTreeWrapperDiv, null, react_1.default.createElement(react_d3_tree_1.default, {
    data: treeData,
    allowForeignObjects: true,
    nodeLabelComponent: {
      render: react_1.default.createElement(node_data_view_component_1.default, {
        handleEditClick: handleEditClick
      }),
      foreignObjectWrapper: {
        width: 400,
        height: 400,
        x: -100,
        y: -50,
        style: {
          overflow: 'visible'
        }
      }
    },
    translate: {
      x: 230,
      y: 300
    },
    pathFunc: pathFunc,
    nodeSize: {
      x: 430,
      y: 470
    },
    initialDepth: depth,
    key: cntRender
  }), react_1.default.createElement(scenario_tree_view_styles_1.StyledButtonWrapperDiv, null, react_1.default.createElement(Button_1.default, {
    color: "primary",
    variant: "outlined",
    onClick: function onClick() {
      return renderDepth(0);
    }
  }, "\u3059\u3079\u3066\u305F\u305F\u3080"), react_1.default.createElement(Button_1.default, {
    color: "primary",
    variant: "outlined",
    onClick: function onClick() {
      return renderDepth(100);
    }
  }, "\u3059\u3079\u3066\u5C55\u958B")));
};

exports.default = ScenarioTreeView;